module.exports = __webpack_public_path__ + "img/4linha.974e5ef9.png";